export var goToItem = function (_a) {
  var itemIndex = _a.itemIndex,
    setActiveItem = _a.setActiveItem,
    modalWrapperElement = _a.modalWrapperElement;
  setActiveItem(itemIndex);
  if (modalWrapperElement) {
    modalWrapperElement.scroll(0, 0);
  }
};
export var goToPreviousItem = function (_a) {
  var activeItem = _a.activeItem,
    setActiveItem = _a.setActiveItem,
    onItemPrev = _a.onItemPrev,
    modalWrapperElement = _a.modalWrapperElement;
  if (activeItem > 0) {
    setActiveItem(function (activeItem) {
      return activeItem - 1;
    });
    if (modalWrapperElement) {
      modalWrapperElement.scroll(0, 0);
    }
    onItemPrev && onItemPrev();
  }
};
export var goToNextItem = function (_a) {
  var activeItem = _a.activeItem,
    setActiveItem = _a.setActiveItem,
    onItemNext = _a.onItemNext,
    modalWrapperElement = _a.modalWrapperElement,
    modalContentList = _a.modalContentList;
  if (activeItem < modalContentList.length - 1) {
    setActiveItem(function (activeItem) {
      return activeItem + 1;
    });
    if (modalWrapperElement) {
      modalWrapperElement.scroll(0, 0);
    }
    onItemNext && onItemNext();
  }
};
export var getRandomItemFromArray = function (array) {
  var randomIndex = Math.floor(Math.random() * array.length);
  var item = array[randomIndex];
  return item;
};
export var paddingToString = function (padding) {
  if (padding === undefined || typeof padding === 'string') return padding;
  return "".concat(padding, "px");
};